import { TourEventBus } from "../event-bus";

function removeAllSteps(): void {
  const stepElements = document.querySelectorAll("div[class*=v-step-]");
  stepElements.forEach((element) => {
    Array.from(element.classList)
      .filter((c) => {
        return c.match(/^v-step-.*/);
      })
      .forEach((e) => {
        element.classList.remove(e);
      });
  });

  TourEventBus.emit("stopOnboarding");
}

const tourCallbacks = {
  onSkip: removeAllSteps,
  onFinish: removeAllSteps,
};

export default tourCallbacks;
